export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export const showSnackbar = (snackbarData) => ({
  type: SHOW_SNACKBAR,
  payload: snackbarData
});

export const hideSnackbar = () => ({
  type: HIDE_SNACKBAR
});
